/** @jsxImportSource theme-ui */
import { useEffect, useState, ReactNode } from 'react'
import { Box } from 'theme-ui'

export const ButtonEntranceEffect = ({
  children,
  delay = 0,
  duration = 0.6,
  className,
}: {
  children: ReactNode
  delay?: number
  duration?: number
  className?: string
}) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, delay)

    return () => clearTimeout(timer)
  }, [delay])

  return (
    <Box
      sx={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible
          ? 'translateY(0px) scale(1)'
          : 'translateY(20px) scale(0.95)',
        filter: isVisible ? 'blur(0px)' : 'blur(4px)',
        transition: `all ${duration}s cubic-bezier(0.16, 1, 0.3, 1)`,
      }}
      className={className}
    >
      {children}
    </Box>
  )
}
